import { IPack } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const packApi = crudEndpointsFactory<IPack>()('packs', 'Packs');